import * as React from "react";
import {
  TextField,
  Show,
  usePermissions,
  Title,
  ReferenceField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
} from "react-admin";
import { ROLE_TYPES } from "../enums/Roles";
import { SimpleShowLayout } from "../common/SimpleShowLayout";

const RestaurantMercadoPagoTokenTitle = () => <Title title={"Mercado Pago"} />;

const RestaurantMercadoPagoTokenShow = () => {
  const { permissions } = usePermissions();
  return (
    <Show title={<RestaurantMercadoPagoTokenTitle />}>
      <SimpleShowLayout>
        {permissions === ROLE_TYPES.ADMIN && (
          <TextField source="id" label="ID" />
        )}
        <ReferenceField
          label="Restaurante"
          reference="restaurants"
          source="restaurant"
          link={false}
        >
          <TextField source="name" label="Nombre" />
        </ReferenceField>
        <ReferenceArrayField
          label="Restaurantes Asociados"
          reference="restaurants"
          source="restaurants"
        >
          <SingleFieldList linkType={false}>
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ReferenceArrayField>
      </SimpleShowLayout>
    </Show>
  );
};

export default RestaurantMercadoPagoTokenShow;
